import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  CmsHelperService,
  CmsUiDynamicContentMenu,
  CmsUiDynamicContentMenuLevel,
  CmsUiDynamicContentQuery,
  CmsUiDynamicPage,
  UrlHelperService,
} from '@lobos/library';

import { Router } from '@angular/router';
import { first, map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-page-redirect',
  template: ``,
})
export class PageRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private translocoService: TranslocoService,
    private urlHelper: UrlHelperService,
    private cmsQuery: CmsUiDynamicContentQuery,
    private cmsHelper: CmsHelperService,
  ) {}

  public ngOnInit(): void {
    this.cmsQuery.cmsMainMenu$
      .pipe(
        untilDestroyed(this),
        first(),
        map((menu: CmsUiDynamicContentMenu) => this.findPageInMenu(this.urlHelper.getPath().substring(3), menu)),
        map((page?: CmsUiDynamicPage) => {
          if (!page) {
            return [this.translocoService.getActiveLang(), 'not-found'];
          }

          return [this.translocoService.getActiveLang(), 'cms', 'page', page.id];
        }),
      )
      .subscribe(async (commands: any[]) => this.router.navigate(commands, { skipLocationChange: true }));
  }

  private findPageInMenu(path: string, menu: CmsUiDynamicContentMenu): CmsUiDynamicPage {
    const allMenuItems: CmsUiDynamicContentMenuLevel[] = this.cmsHelper.flattenMenu(menu);

    const item: any = allMenuItems.find((entry: CmsUiDynamicContentMenuLevel) => entry.slug === path);
    return item?.page;
  }
}
